import React, {Component} from 'react'
import styled from 'styled-components'
import image1 from '../assets/photos/IMG_7847.jpg'
import image2 from '../assets/photos/IMG_7046.jpg'
import image3 from '../assets/photos/IMG_8074.jpg'
import image4 from '../assets/photos/IMG_8107.jpg'
import image5 from '../assets/photos/IMG_7713.jpg'
import image6 from '../assets/photos/IMG_7874.jpg'

const H2 = styled.h2`
        font-size:4rem;
        text-align:center;
        @media only screen and (max-width:800px){
            font-size:2.5rem;
            margin:0rem;
        }
        `

        const Div = styled.div`
            width:100%;
            margin-top:8rem;
            background:rgb(20,20,20);
            position:relative;
            color:rgba(220,220,220);
            display:grid;
            grid-template-rows:50% 50%;
            height:100vh;
            gap:0.5rem;
            grid-template-columns:1fr 1fr 1fr;

            @media only screen and (max-width:600px){
                grid-template-rows:33.3% 33.3% 33.4%;
                grid-template-columns:50% 50%;
            }

            & img{
                width:100%;
                height:100%;
                object-fit:cover;
                filter:grayscale(50%) contrast(75%);
                display:block;
            }

            &::after{
                width:100%;
                height:100%;
                content:"";
                position:absolute;
                top:0;
                left:0;
                background:radial-gradient(rgba(40,40,40,0.300),black);
            }
          
        `

        const Form = styled.form`
            position:absolute;
            box-sizing:border-box;
            z-index:1;
            width:100%;
            display:grid;
            grid-template-columns:50% 50%;
            @media only screen and (max-width:800px){
                grid-template-columns:100%;
                grid-template-rows:50% 50%;
                row-gap:1rem;
                padding-top:2rem;
                align-content:center;
                justify-content:center;
            }
            padding:1rem;
        `
        const InputsContainer = styled.div`
            display:grid;
            grid-template-columns:80%;
            gap:2rem;
            justify-content:center;
            & input,textarea{
                font-family:inherit;
                font-size:1rem;
                border:none;
                outline:none;
                padding:0.5rem;
                padding-bottom:0.1rem;
                transition:0.3s;
                box-sizing:border-box;
                border-bottom:0.4rem solid transparent;
                

                &:focus{
                    background:#d1a3a3;
                }
            }
            @media only screen and (max-width:800px){
                gap:1rem;
            }

          
        `

            const Button = styled.button`
                font-family:inherit;
                font-size:1rem;
                padding:1rem 2rem;
                border:none;
                margin-top:-2.2rem;
                background:rgb(150,20,20);
                color:white;
                cursor:pointer;
                transition:0.2s;
                width:100%;
                z-index:10;
                &:hover{
                    opacity:0.6;
                }
            
            `

            const ContactInfo = styled.div`
                background:transparent;
                display:flex;
                flex-direction:column;
                justify-content:center;
                text-align:left;

                & h3{
                    font-size:1.5rem;
                    padding:1rem;
                    text-shadow:2px 2px 2px black;
                    border-bottom:3px solid rgba(100,100,100,.700);

                    @media only screen and (max-width:800px){
                        font-size:0.9rem;
                        padding:0.5rem;
                    }
                }
                & div{
                    background:black;
                    display:flex;
                    justify-content:space-evenly;
                    padding:1rem 0;
                    border-radius:10px;
                    flex-wrap:wrap;
                    font-weight:900;
                    @media only screen and (max-width:800px){
                        font-size:0.9rem;
         
                    }
                }
                & a{
                    color:rgb(250,0,0);
                    transition:0.1s;
                    &:hover{
                        color:rgb(150,0,0)
                    }
                    
                }
            `


export default class extends Component{
    constructor(props){
        super(props)
        this.state = {
            submitted:false,
            loaded:false
        }
    }

    encode = (data) => {
        return Object.keys(data)
            .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
            .join("&");
      }

    componentDidMount(){
       document.addEventListener('scroll',e=>{
           if(document.getElementById('contact-section').getBoundingClientRect().top <= window.scrollY-500){
               this.setState({loaded:true})
           }
        
       })
        
    }
    

    submitFormHandler =  async (event)=>{
       
        event.preventDefault()
        const formData = {
            name:document.getElementById('name').value,
            email:document.getElementById('email').value,
            title:document.getElementById('title').value,
            message:document.getElementById('message').value,
        }
        


        fetch('/', {
            method: 'POST',
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body:this.encode({"form-name":"contact",...formData}),
        }).then((data) => {
            this.setState({submitted:true})
            console.log(data)
        }).catch((error) => {
            this.setState({submitted:true})
            alert(error)})

    }


    
    render(){
        

        return(
            <div id="contact-section">
                {<Div>
                
                <Form 
                onSubmit={this.submitFormHandler} 
                id="contact-form"
                method="post"
                
                >
                {!this.state.submitted ? <InputsContainer>
                        <H2>Contact</H2>
                        <input type="hidden" name="form-name" value="contact" />
                        <input required name="name" id="name" placeholder="Your name here" type="text"/>
                        <input required name="email" id="email" placeholder="Your email here" type="email"/>
                        <input required name="title" id="title" placeholder="Your title here" type="text"/>
                        <textarea required name="message" id="message" placeholder="Your message here" cols="30" rows="10"></textarea>
                        <Button type="submit" value="Send">Submit</Button>
                    </InputsContainer> : <H2 className="fadein">Thanks for your submission!</H2>} 
                 
                    <ContactInfo>
                        <h3>Location: Roanoke, VA</h3>
                        <h3>Email: Exalted@cox.net </h3>
                        <h3>Rick Drewery: (540) 580-2982</h3>
                        <div>
                        <a target="_blank" href="https://www.facebook.com/exaltedchristianband">Facebook</a> <a target="_blank" href="https://www.instagram.com/Exalted_Christian_Band/?fbclid=IwAR1XBbD9vd7KPgNgbuuDgUkB_Y2i4uVPWgcmkV-2cMkVmhaxmaaMrAd97I8">Instagram</a>  <a target="_blank" href="https://l.facebook.com/l.php?u=https%3A%2F%2Fwww.youtube.com%2Fchannel%2FUCvRXM1cFHBSyhjNw5LiUfRQ%3Ffbclid%3DIwAR28q7l2ClOCl0xBtrbJvWncYnC1YO_lWNpG7on5bL9zYB3NKmwBBGP1kMQ&h=AT095N38_Joh_5g2rb271lEbX39tngqrrERI28whoO0h4iO8yz03dsFAsw8XrEPnaBo3k0LqmsXXf73CC4618quKrabXAp6yNnVD5DDGdj8JvSpBFYIyWrQkSbHelTm0cPy7spk4C_xK">Youtube</a> <a target="_blank" href="http://www.exaltedministries.com/">Exalted Church</a>
                        </div>

                    </ContactInfo>

                
                </Form>

                {this.state.loaded && <React.Fragment>

                    <img src={image1} alt=""/>
                    <img src={image2} alt=""/>
                    <img src={image3} alt=""/>
                    <img src={image4} alt=""/>
                    <img src={image5} alt=""/>
                    <img src={image6} alt=""/>

                </React.Fragment>}
              
            </Div>
                }
            
            </div>
            
        )
    }
}